import { styled as r, excludeProps as o } from "@lokalise/styled";
import { spacing as t } from "../../utils/theme/index.js";
import { withInputStyle as e } from "../../utils/styles/inputStyle.js";
const p = r.textarea.withConfig({ shouldForwardProp: o(["error"]) })`
	${e};
	padding: ${t(3)};
	max-width: 100%;
`, n = r.div`
	width: 100%;
	display: grid;
	gap: ${t(1)};
	grid-template-columns: minmax(50px, 1fr); /* This ensures Textarea doesn't overflow 100% */
`;
export {
  n as Container,
  p as Textarea
};
//# sourceMappingURL=styles.js.map
